import { connect } from 'react-redux';
import {
  getCurrentLocale,
  getFieldValue,
  getInstructionByName,
  getInstructionsType,
  getLinks,
  getOfferName,
  getPayment,
  getPaymentInstructions,
  getPaymentOfferFromPayment,
  getPaymentPrice,
  getPublicKey,
  getRecipientName,
  isEmbedded,
  isOppOfferSelected,
} from 'selectors';
import {
  forceRedirectInNewWindow,
  isBoleto,
} from 'selectors/entities/offers/offers';
import { OnlineComponent } from './Online';

const mapStateToProps = state => {
  const payment = getPayment(state);
  const { paymentOption } = getPaymentOfferFromPayment(state);

  return {
    embedded: isEmbedded(state),
    embeddedScript: getInstructionByName(state, 'embedded_script'),
    forceRedirectInNewWindow: forceRedirectInNewWindow(state),
    isBoleto: isBoleto(state),
    isOppOfferSelected: isOppOfferSelected(state),
    locale: getCurrentLocale(state),
    offerName: getOfferName(state, payment.offer.id),
    paymentLinks: getLinks(state),
    paymentId: payment.id,
    publicKey: getPublicKey(state),
    price: getPaymentPrice(state),
    redirectUrl: getInstructionByName(state, 'redirect_url'),
    returnUrl: getFieldValue(state, 'return_url'),
    scriptSignature: getInstructionByName(state, 'script_signature'),
    requiresAuthentication: getInstructionByName(
      state,
      'requires_authentication',
    ),
    uuidTokenInstruction: getInstructionByName(state, 'uuid_token'),
    instructionsType: getInstructionsType(state),
    paymentOption,
    instructions: getPaymentInstructions(state),
    recipientName: getRecipientName(state),
  };
};

export const Online = connect(mapStateToProps, null)(OnlineComponent);
